import { z } from 'zod';
import { TFunction } from '../_hooks/useAddProductSchema';

const regex =
  /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u0020-\u007E\u00A0-\u00FF\u0100-\u024F0-9!@#$%^&*()_+={}[\]:;"'<>,.?/\\|\s-]*$/;

export const getSpecificationsSchema = (t: TFunction, tComponents: TFunction) => z.object({
  specs: z.array(
    z.object({
      type: z.string()
        .trim()
        .min(1, { message: t('requiredField') })
        .regex(regex, { message: tComponents('arabic_english_char_numbers') }),
      value: z.string()
        .trim()
        .min(1, { message: t('requiredField') })
        .regex(regex, { message: tComponents('arabic_english_char_numbers') }),
    })
  )
    .min(2, { message: t('specsMinMax', { min: 2, max: 10 }) })
    .max(10, { message: t('specsMinMax', { min: 2, max: 10 }) }),
  itemPerCarton: z.preprocess(
    (val) => (val === '' || val === undefined || val === null ? undefined : Number(val)),
    z.number({ required_error: t('requiredField'), invalid_type_error: t('requiredField') }).int().positive({ message: t('acceptNumbersOnly') })
  ),
  grossWeight: z.preprocess(
    (val) => (val === '' || val === undefined || val === null ? undefined : Number(val)),
    z.number({ required_error: t('requiredField'), invalid_type_error: t('requiredField') }).positive({ message: t('acceptNumbersOnly') })
  ),
  height: z.preprocess(
    (val) => (val === '' || val === undefined || val === null ? undefined : Number(val)),
    z.number({ required_error: t('requiredField'), invalid_type_error: t('requiredField') }).positive({ message: t('acceptNumbersOnly') })
  ),
  width: z.preprocess(
    (val) => (val === '' || val === undefined || val === null ? undefined : Number(val)),
    z.number({ required_error: t('requiredField'), invalid_type_error: t('requiredField') }).positive({ message: t('acceptNumbersOnly') })
  ),
  length: z.preprocess(
    (val) => (val === '' || val === undefined || val === null ? undefined : Number(val)),
    z.number({ required_error: t('requiredField'), invalid_type_error: t('requiredField') }).positive({ message: t('acceptNumbersOnly') })
  ),
});
